import { atom } from "recoil";

export const apiResponseState: any = atom({
  key: "apiResponseState", // Deve ser único dentro do sistema Recoil
  default: null, // Valor inicial do estado
});
